import { useCallback, useEffect, useState } from "react";
import worklistApi from "../services/worklistApi";
import { ColumnConfig, TabConfig } from "../types";
import { isAbort } from "../utils";

// Tabs + columns from TabColumnsV2.
export function useTabConfig() {
  const [tabs, setTabs] = useState<TabConfig[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const load = useCallback(async (signal?: AbortSignal) => {
    setLoading(true);
    setError(null);
    try {
      setTabs(await worklistApi.getTabColumns(signal));
    } catch (e) {
      if (!isAbort(e)) setError("Could not load tab configuration.");
    } finally {
      if (!signal?.aborted) setLoading(false);
    }
  }, []);

  useEffect(() => {
    const ac = new AbortController();
    load(ac.signal);
    return () => ac.abort();
  }, [load]);

  // Save the layout (full ordered list) and reload; the server evicts its cache on save.
  const saveColumns = useCallback(
    async (tabId: number, columns: Pick<ColumnConfig, "id" | "isShow">[]) => {
      await worklistApi.saveColumns(tabId, columns);
      await load();
    },
    [load]
  );

  return { tabs, loading, error, reload: load, saveColumns };
}
